import { APISettings } from "../../config/ApiSettings";
import { BaseAPI } from "./baseApi";

const baseUrl = new APISettings().getApiURL();

class FilingNoteApi<FilingNote> extends BaseAPI {
  public getById: (id: number) => Promise<FilingNote> = async (id: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/FilingNote/${id}`)).data.output;
  }

  public getByFilingId: (filingId: number) => Promise<FilingNote> = async (filingId: number) => {
    return (await BaseAPI.axios.get(`${baseUrl}/FilingNote/GetByFilingId/${filingId}`)).data.output;
  }

  public createFilingNote: (filingNote: FilingNote) => Promise<FilingNote> = async (filingNote: FilingNote) => {
    return (await BaseAPI.axios.post(`${baseUrl}/FilingNote`, filingNote)).data.output;
  }
}

export const filingNoteApi = new FilingNoteApi();